import palette from "./palette";
import common from "./common.js";

// night theme
const styles = {
  ...common.styles,
  palette: {
    ...common.styles.palette,
    selected: {
      main: palette.red,
      contrastText: palette.white
    },
    mode: "dark",
    background: {
      default: palette.dark_grey,
      rgb: palette.dark_grey_rgb,
      contrast: palette.white,
      unlockInstructions: 'transparent'
    },
    text: {
      unlockInstructions: palette.white
    }
  },
  components: {
    ...common.styles.components,
    MuiBackdrop: {
      styleOverrides: {
        root: { background: palette.dark_grey + "EE" },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { background: palette.dark_grey },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { background: palette.white },
      },
    },
  },
};

const image_dir = "./night";

const night = { styles, image_dir };

export default night;
